import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { HomecarePlanProposalsList } from "@/features/admin/homecare-plan-proposals/list";
import { HomecarePlanProposalGate } from "@/features/shared/feature-gates/homecare-plan-proposal-gate";
import {
  filterSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

/**
 * `proposalId` selects the row whose detail panel is open — the same
 * `<id>Id` search-param convention the other admin list routes use, so a
 * deep link opens the list with that plan expanded.
 */
const searchSchema = z.object({
  proposalId: z.string().optional(),
  filters: z
    .object({
      status: withOperators(commaListSchema),
      createdBy: withOperators(commaListSchema),
    })
    .optional(),
  ...filterSearchFragment,
  sort: z.string().optional(),
  ...maskSearchFragment,
});

export type HomecarePlanProposalsListSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/admin/homecare-plan-proposals/")({
  validateSearch: searchSchema,
  component: () => (
    <HomecarePlanProposalGate>
      <HomecarePlanProposalsList />
    </HomecarePlanProposalGate>
  ),
});
